import { call, put, takeLatest } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { POST } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import {
  CREATE_SELL_CONTRACT,
  CREATE_SELL_CONTRACT_FAILURE,
  CREATE_SELL_CONTRACT_SUCCESS,
  CreateSellContractActionType
} from 'src/redux/sellContractReducer'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* CreateSellContractFlow(action: CreateSellContractActionType): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    const endpoint = '/dealers_api/sell_contracts'
    const response: { pdf_url: string } = yield call(apiCall, {
      endpoint,
      api: 'market-api',
      method: POST,
      params: {
        sell_contract: action.payload
      }
    })
    yield put(CREATE_SELL_CONTRACT_SUCCESS({ pdf_url: response.pdf_url }))
  } catch (error) {
    yield put(CREATE_SELL_CONTRACT_FAILURE())
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* CreateSellContractSaga(): Generator<any, void, any> {
  yield takeLatest(CREATE_SELL_CONTRACT, CreateSellContractFlow)
}
